const pageFadeDurationMs = 225;
const lightboxModal = "_35sl1b6b3ke";
const root = "_35sr15538wk";
const wrapper = "_35sw1q1j5gp";
const header = "_35sh107x5c8";
const saveIndicatorPlaceholder = "_35ss1arworr";
const saveIndicatorWrapper = "_35ss1ba1qzj";
const saveIndicator = "_35ss1l7uk81";
const elementToolbarPlaceholder = "_35se1nzryqj";
const elementToolbar = "_35se1yt9lhb";
const actionsWrapper = "_35sa1o122hk";
const actions = "_35sawors6j";
const componentWrapper = "_35sc183mzyw";
const contentWrapper = "_35sc1gnnynb";
const content = "_35sc1oe715e";
const speechButtonWrapper = "_35ss11y5zty";
const speechButtonSticky = "_35ssl56cf4";
const mobileFullscreenButton = "_35sm1mii4ou";

export { actions, actionsWrapper, componentWrapper, content, contentWrapper, elementToolbar, elementToolbarPlaceholder, header, lightboxModal, mobileFullscreenButton, pageFadeDurationMs, root, saveIndicator, saveIndicatorPlaceholder, saveIndicatorWrapper, speechButtonSticky, speechButtonWrapper, wrapper };
import "./_component.style.linaria.module.css";
//# sourceMappingURL=_component.style.js.map
